<app-page-form-section title="Warehouse Work History"
  subtitle="Recorded confirmations from rollout onward. Older activity is legacy history.">
  <p-table [value]="rows" styleClass="p-datatable-sm p-datatable-gridlines warehousing-data-table"
    [paginator]="rows.length > 20" [rows]="20" [tableStyle]="{ 'min-width': '62rem' }">
    <ng-template pTemplate="header">
      <tr>
        <th>UTC Time</th><th>Action</th><th>Status</th><th>Method</th><th>Unit</th>
        <th>Quantity</th><th>State</th><th>Operator</th><th>Reason / Failure</th><th>Batch</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.occurredAt | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}</td>
        <td>{{ row.action }}</td>
        <td><p-tag [value]="row.status" [severity]="row.status === 'REJECTED' ? 'danger' : 'success'"></p-tag></td>
        <td><p-tag [value]="methodLabel(row.method)"></p-tag></td>
        <td>{{ row.stockUnitId || '-' }}</td>
        <td>{{ row.quantity ?? '-' }}</td>
        <td>{{ row.beforeState || '-' }} → {{ row.afterState || '-' }}</td>
        <td>{{ row.actorId || '-' }}</td>
        <td>{{ row.reason || '-' }}<br *ngIf="row.failure"><small>{{ row.failure }}</small></td>
        <td><small>{{ row.batchId }}<br *ngIf="row.correlationId">{{ row.correlationId }}</small></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="10">No new work events recorded. Earlier actions remain legacy records.</td></tr>
    </ng-template>
  </p-table>
</app-page-form-section>
